import React from 'react';
import { IProductData } from 'interfaces/IProductData';
import YoutubeEmbed from '../../YoutubeEmbed';
import Translate from 'components/Translate';
import Hidden from '@material-ui/core/Hidden';
import { getCdnImage } from 'functions';
import { enProductType } from 'enums/enProductType';
import { TicketTimer } from '../TicketTimer/index';
import { Locale } from '../Locale';
import { WithStyles } from 'shared/decorators/withStyles';
import { nl2br } from 'shared/functions';
import { ticketService } from 'services/TicketService';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { Grid, Button } from '@material-ui/core';
import HeaderTitle from '../Templates/Mobile/MultiStep/HeaderTitle';

interface IProps {
  cart: IProductData;
  classes?: any;
  handleClose?: () => void;
}

interface IState extends IStateBase {
  showTimer: boolean;
}

@WithStyles(() => ({
  component: {
    outline: 'none',
    '& .chk-banner-right': {
      padding: '20px',
      backgroundColor: '#fff',
      border: '1px solid #e8e7e7',
      borderRadius: '4px',
      '&.timer': {
        margin: '0 0 20px 0'
      },

      '& .chk-img': {
        padding: '0 4px 4px',
        border: '1px solid #e2e2e2'
      },

      '& .product-name': {
        textAlign: 'left'
      },

      '& .open-modal-description': {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginBottom: '10px',
        width: '100%'
      },

      '&.locale': {
        margin: '20px 0 0 0'
      },

      '@media screen and (max-width: 600px)': {
        height: '70vh',
        maxWidth: '90vw',
        overflowY: 'scroll',
        width: '100%'
      }
    },
    '& .closeButtonGrid': {
      backgroundColor: '#FFF',
      borderTop: '1px solid #cecece',
      display: 'flex',
      justifyContent: 'center',
      paddingBottom: '14px',
      position: 'relative',
      width: '90vw',

      '& .closeButton': {
        fontWeight: 600,
        letterSpacing: '0.5px',
        borderRadius: '3px',
        color: '#009358',
        fontSize: '0.875rem',
        height: '40px',
        padding: '7px 18px',
        marginTop: '16px',
        boxShadow: '1px 1px 1px RGBA(0,0,0,0.2)'
      }
    },
    '& .alert': {
      fontSize: '0.675rem',
      color: '#2E2E2E',

      '@media screen and (max-width: 600px)': {
        position: 'relative',
        top: '2px'
      }
    },

    '& .tooltip': {
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '15px',
      fontStyle: 'italic'
    },

    '& img': {
      width: '100%'
    },

    '& .chk-youtube': {
      margin: '0 0 16px 0',
      height: '100%',
      '@media screen and (max-width: 600px)': {
        height: 'auto'
      }
    },

    '& .chk-sideBar__description': {
      fontSize: '0.875rem',
      borderRadius: '4px',
      boxSizing: 'border-box',
      lineHeight: '1.333rem',

      '& .title': {
        margin: '0 0 14px 0px',

        '& span': {
          fontSize: '0.75rem',
          fontWeight: 700,
          textTransform: 'uppercase'
        }
      },

      '& .content-description': {
        color: '#807e7e',
        wordBreak: 'break-word'
      },

      '& .infos': {
        borderTop: '1px solid #cecece',
        padding: '8px 0 0',
        fontSize: '0.875rem',
        margin: '8px 0 0 0',

        '& .producerName': {
          display: 'inline-block'
        }
      }
    }
  }
}))
export class Sidebar extends BaseComponent<IState, IProps> {
  constructor(props: any) {
    super(props);
    this.state = { showTimer: false };
  }

  componentDidMount() {
    ticketService
      .show()
      .bindComponent(this)
      .subscribe(showTimer => {
        this.setState({ showTimer });
      });
  }

  render() {
    const props = this.props;
    const showTimer = this.state.showTimer;

    const bannerId = props.cart.config.template.media.bannerRight;

    const bannerUrl = getCdnImage(bannerId);

    const product = props.cart.content;

    return (
      <div className={this.props.classes.component}>
        {showTimer && props.cart.config.productType == enProductType.TICKET && (
          <div>
            <Hidden xsDown>
              <div className={'chk-banner-right timer'}>
                <TicketTimer />
              </div>
            </Hidden>
          </div>
        )}

        <div className={'chk-banner-right'}>
          <Hidden smUp>
            <Grid container spacing={8}>
              <HeaderTitle
                cart={props.cart}
                shouldRenderModal={false}
              />
            </Grid>
          </Hidden>
          <Hidden>
            <YoutubeEmbed url={props.cart.config.template.media.bannerYoutube} />
            {bannerId ? (
              <img alt={props.cart.content.title} src={bannerUrl.includes('data:') ? bannerId : bannerUrl} />
            ) : (
              <div className="chk-sideBar__description">
                <div className="title">
                  <Translate term="Detalhes" />
                </div>
                <div className="content-description" dangerouslySetInnerHTML={{ __html: nl2br(product.description) }} />
                {product.producerName && (
                  <div className="infos">
                    <span className="producerName">
                      <Translate term="Oferecido por" /> <b>{product.producerName}</b>
                    </span>
                    <br />
                    <span>{product.producerEmail}</span>
                  </div>
                )}
              </div>
            )}
          </Hidden>
        </div>
        {showTimer && props.cart.config.productType == enProductType.TICKET ? (
          <Hidden xsDown>
            <div className={'chk-banner-right locale'}>
              <Locale />
            </div>
          </Hidden>
        ) : null}
        <Hidden smUp>
          <div className="closeButtonGrid">
            <Button
              onClick={props.handleClose}
              size='large'
              color='primary'
              className='closeButton theme-button'
            >
              <Translate term='Voltar ao carrinho' />
            </Button>
          </div>
        </Hidden>
      </div>
    );
  }
}
